const translates = {
	hamburgerMenu: {
		base: '110vw',
		medium: 'calc(40rem + 40vw)',
	},
};

export default translates;
